import './App.css';
import { Routes, Route } from 'react-router-dom';
import { NavBar } from './components/NavBar';
import { Banner } from './components/Banner';
import { Skills } from './components/Skills';
import { Projects} from './components/Projects';
import {Contact} from './components/Contact';
import {Footer} from './components/Footer';
import 'bootstrap/dist/css/bootstrap.min.css'
// import 'dotenv/config';



function App() {
  return (
    <div className="App">
      <NavBar/>
      <Routes>
        <Route path="*" element={<Banner/>} />
        <Route path="/" element={<Banner/>} />
        <Route path="skills" element={<Skills />} />
        <Route path="projects" element={<Projects />} />
        <Route path="contact" element={<Contact />} />
      </Routes>

       
       
       {/* <Skills/>
       <Projects/>
       <Contact/> */}
       <Footer/>
    </div>
  );
}

export default App;
